<template>

<v-dialog v-model="dialog" width="400px">
  <v-card>
    <p class=".title ma-2">Move Guest payment to another booking</p>
    <v-form ref="mvHklrPaymentTransfer" v-model="mvHklrPaymentTransferValid1">

      <br />
      <p class="mx-2">     
       <v-select v-model="hklr_nr" required :items="hklr_nrKeuzes" item-value="hklr_nr" item-text="hklr_oms" label="Payment" dense :rules="hklr_nrRules"></v-select>
      </p>     
     
      <p class="mx-2">
          <v-text-field v-model="hklr_bedrag" required label="Amount to move" :prefix=hklr.valu_code type="number" :rules="hklr_bedragRules"></v-text-field>
      </p>
    
      <p class="mx-2">
          <v-text-field v-model="huov_code_moveto" required label="Booking ID where the payment moves to" :rules="huov_code_movetoRules"></v-text-field>
      </p>    
       
      <p v-if="hklr.huov_moveto_huis_code > ''" class="mx-2">
          
      Accommodation: {{hklr.huov_moveto_huis_code}} <br />
      Arrival: {{hklr.huov_moveto_vandat}} Departure: {{hklr.huov_moveto_tmdat}}<br />
      Guest: {{hklr.huov_moveto_klnt}} 
      </p>
      
      


    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="hklr.huov_moveto_huis_code > ''" class="primary mx-2" small @click="mvHklrPaymentTransfer" :disabled="!mvHklrPaymentTransferValid1">Move payment</v-btn>
      <v-btn class="primary mx-2" small @click="mvHklrPaymentTransferCheck" :disabled="!mvHklrPaymentTransferValid1">Check this data</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      mvHklrPaymentTransferValid1: false,
      huov_encrid: null,
      hklr_nr: '',
      hklr_bedrag: null,
      huov_code_moveto: null,
      hklr_nrKeuzes: [],
      hklr: {},
      hklr_nrRules: [
          v => (v && v.length >= 1) || "An code is required"
      ],
      huov_code_movetoRules: [
          v => (v && v.length >= 1) || "A booking ID is required"
      ],  
      hklr_bedragRules: [
          v => (v && v.length >= 1) || "An amount is required"
      ]    
    }
  },
  methods: {
    open(huov_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huov_encrid = huov_encrid;
      this.hklr_nrKeuzes.length = 0;
      this.hklr_dt = '';
      this.hklr_bedrag = '';
      this.hklr_nr = '';
      this.$axios
        .post("ares/json/ares/huov/hklr/getHklrToMvHklrPaymentTransfer.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHklrToMvHklrPaymentTransfer"
          },
          getHklrToMvHklrPaymentTransfer: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hklr = res.data.getHklrToMvHklrPaymentTransfer;
            res.data.getHklrToMvHklrPaymentTransfer.hklr_nrKeuzes.forEach(function(hklr) {
                deze.hklr_nrKeuzes.push(hklr); 
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    mvHklrPaymentTransferCheck() { 
      this.$axios
        .post("ares/json/ares/huov/hklr/mvHklrPaymentTransferCheck.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "mvHklrPaymentTransferCheck"
          },
          mvHklrPaymentTransferCheck: {
            huov_encrid: this.huov_encrid,
            hklr_nr: this.hklr_nr,
            huov_code_moveto: this.huov_code_moveto,
            hklr_bedrag: parseFloat(this.hklr_bedrag)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {    
               this.hklr = res.data.mvHklrPaymentTransferCheck;  
              if (res.data.mvHklrPaymentTransferCheck.color == "error") {
                  this.$store.dispatch('setSnackbar', {
                        showing: true,
                        text: res.data.mvHklrPaymentTransferCheck.text,
                        color: res.data.mvHklrPaymentTransferCheck.color
                  }); 
              }  
          }
        })
    },
    mvHklrPaymentTransfer() { 
      this.$axios
        .post("ares/json/ares/huov/hklr/mvHklrPaymentTransfer.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "mvHklrPaymentTransfer"
          },
          mvHklrPaymentTransfer: {
            huov_encrid: this.huov_encrid,
            hklr_nr: this.hklr_nr,
            huov_code_moveto: this.huov_code_moveto,
            hklr_bedrag: parseFloat(this.hklr_bedrag)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.mvHklrPaymentTransfer.text,
              color: res.data.mvHklrPaymentTransfer.color
            }); 
             if (res.data.mvHklrPaymentTransfer.color == "success" ) {
              setTimeout(() => { this.$router.reload("/huov/onHuov/" + res.data.mvHklrPaymentTransfer.huov_encrid); }, 1000); 
            }   
             
            this.dialog = false;
          }
        })
    },
  }
}
</script>

